import React from 'react';
import './PairingDates.scss';

export default function PairingDates({ month, year, daysToShowLastMonth, daysToShowSelectedMonth, daysToShowNextMonth }) {
  const DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const DAYS_OF_THE_WEEK = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

  const selectedMonth0Indexed = month? month-1 : 0;
  const startDay = getStartDayOfMonth();
  const calenderStartDay = (startDay - 2) === -1? 6 : (startDay - 2);

  function getStartDayOfMonth() {
    const startDate = new Date(year, selectedMonth0Indexed, 1).getDay();
    return startDate === 0 ? 7 : startDate;
  }

  function isLeapYear(year: number) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  const days = isLeapYear(year) ? DAYS_LEAP : DAYS;
  const numDaysInSelectedMonth = days[selectedMonth0Indexed];

  return (
    <div className='pairing-dates-container'>
      <div className='content'>
        {DAYS_OF_THE_WEEK.map((d) => (
          <div className='day table-header' key={d}>
            {d}
          </div>
        ))}
        {Array(42)
          .fill(null)
          .map((_, index) => {
            const d = index - calenderStartDay;
            return (
              <div className='day' key={index}>
                {( d > numDaysInSelectedMonth && daysToShowNextMonth.includes(d-numDaysInSelectedMonth) )? d-numDaysInSelectedMonth: ( d > 0 && daysToShowSelectedMonth.includes(d) ) ? d : ( d<=0 && daysToShowLastMonth.includes(days[selectedMonth0Indexed-1] + d) ) ? (days[selectedMonth0Indexed-1] + d) : `--`}
              </div>
            );
          })}
      </div>
    </div>
  );
}
